import { useState } from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Layers, Lightbulb, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import UserMenu from "@/components/UserMenu";
import PremiumModal from "@/components/PremiumModal";

const navItems = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { path: "/pattern-match", label: "Pattern Match", icon: Layers },
  { path: "/predictions", label: "Predictions", icon: Lightbulb },
];

export default function Layout() {
  const location = useLocation();
  const [premiumModalOpen, setPremiumModalOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#09090B]" data-testid="app-layout">
      <aside className="fixed left-0 top-0 h-full w-64 border-r border-[#27272A] bg-[#09090B] z-50 flex flex-col">
        <div className="p-4 border-b border-[#27272A] flex items-center justify-center">
          <img src="/logo.png" alt="Stock Correlations" className="w-48 h-auto rounded-lg" />
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            const isActive = item.exact
              ? location.pathname === "/" || location.pathname === "/dashboard"
              : location.pathname.startsWith(item.path);
            const Icon = item.icon;
            return (
              <NavLink key={item.path} to={item.path}
                className={cn("flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors rounded-lg",
                  isActive ? "nav-active text-[#38BDF8] bg-[#18181B]" : "text-[#A1A1AA] hover:text-white hover:bg-[#18181B]"
                )}>
                <Icon className="w-5 h-5" />
                <span className="font-body">{item.label}</span>
                {isActive && <ChevronRight className="w-4 h-4 ml-auto" />}
              </NavLink>
            );
          })}
        </nav>

        <div className="p-4 border-t border-[#27272A] space-y-3">
          <UserMenu onUpgrade={() => setPremiumModalOpen(true)} />
          <div className="text-xs text-[#52525B] font-data">
            <p>DATA SOURCES</p>
            <p className="mt-1 text-[#A1A1AA]">Open-Meteo · Yahoo Finance · ASX</p>
          </div>
        </div>
      </aside>

      <main className="pl-64 w-full min-h-screen">
        <Outlet />
      </main>

      {/* Global Premium modal — triggered from sidebar UserMenu */}
      <PremiumModal
        open={premiumModalOpen}
        onClose={() => setPremiumModalOpen(false)}
        featureName="Premium features"
      />
    </div>
  );
}
